import deleteAnswerFile from "./deleteAnswerFile";
import saveAnswerFile from "./saveAnswerFile";

const checkAnswerFiles = async (savedAnswer, updatedAnswer) => {
	if (updatedAnswer?.files) {
		for (const file of updatedAnswer.files) {
			if (file instanceof File) {
				await saveAnswerFile(file, savedAnswer.id);
			}
		}
	}
	if (savedAnswer?.files) {
		for (const savedFile of savedAnswer.files) {
			if (!updatedAnswer.files.find((file) => savedFile.id === file.id)) {
				await deleteAnswerFile(savedFile.id, savedAnswer.id);
			}
		}
	}
};
export default checkAnswerFiles;
